import React, { useState, useEffect } from 'react';
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from 'react-router-dom';
import { Button, FormControlLabel, Radio, Typography, List, ListItem, CircularProgress } from '@mui/material';
import order_complete from '../../User/assets/order-successful.svg'
import instance from '../../Utils/api';
import Image from '../../Utils/getImage';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Admin_addAddress from './Admin_addAddress';
import Grid from '@mui/material/Grid2';


const Ordereduser = ({ selectedItems, customerId, consultationId }) => {
    const navigate = useNavigate();
    const [address, setAddress] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const steps = ['Your order', 'Pickup address', 'Order successfully'];
    const [loading, setLoading] = useState(false);


    //FetchAddress
    const FetchAddress = async () => {
        try {
            const response = await instance.get(`/Address/getAddress?user_id=${customerId}`);
            setAddress(response?.data?.data);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        FetchAddress();
    }, []);

    //assign order
    const handleCreateorder = async () => {
        if (!selectedAddress) {
            toast.error('Please select an address before proceeding');
            return;
        }
        try {
            setLoading(true);
            const data = {
                selected_items: selectedItems.map((item) => item._id),
                address: selectedAddress?._id,
                customer_id: customerId,
                orderBy: 'Admin',
                consultationId
            }
            const response = await instance.post('/Order/createOrder', data)
            if (response.data.success === true) {
                toast.success(response?.data?.message)
                setCurrentStep(2);
                setTimeout(() => {
                    navigate('/admin/users');
                }, 2000);
            } else {
                toast.error(response?.data?.message)
            }
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message)
        } finally {
            setLoading(false);
        }
    }


    return (
        <React.Fragment>
            <div className='cart-main-title'>
                <div className='cart-title-left'>
                    <Button startIcon={<KeyboardBackspaceIcon />} onClick={() => navigate(-1)}>
                        Back
                    </Button>
                </div>
                <div className='cart-title-center'>
                    <Typography variant='h4'>My Cart</Typography>
                </div>
            </div>
            <React.Fragment>
                <div className="stepper-wrapper">
                    {steps.map((step, index) => (
                        <div
                            key={index}
                            className={`stepper-item ${index < currentStep ? 'completed' : ''} ${index === currentStep ? 'active' : ''}`}
                            onClick={() => {
                                if (index <= currentStep) {
                                    setCurrentStep(index);
                                }
                            }}
                            style={{ cursor: index <= currentStep ? 'pointer' : 'not-allowed' }}
                        >
                            <div className="step-counter"></div>
                            <div className="step-name">{step}</div>
                        </div>
                    ))}
                </div>

                <div className="step-content">
                    {currentStep === 0 && (
                        <React.Fragment>
                            {selectedItems.map((item, index) => (
                                <div className='ordered-list' key={index}>
                                    <div className="ordered-image">
                                        <Image src={item?.design_id?.picture ? item?.design_id?.picture[0] : item?.design_id?.picture} alt="picture" width={200} height={185} />
                                    </div>
                                    <div className='ordered-content'>
                                        <Typography><span style={{ color: " #032a4b" }}>Name</span> :  {item?.design_id?.name ? item?.design_id?.name : item?.name}</Typography>
                                        <Typography><span style={{ color: " #032a4b" }}>Descritpion</span> : {item?.design_id?.description}</Typography>
                                        <Typography><span style={{ color: " #032a4b" }}>Quantity</span> : {item?.quantity}</Typography>
                                        <Typography><span style={{ color: " #032a4b" }}>Price</span> : {item?.design_id?.price ? item?.design_id?.price : item?.price}</Typography>
                                        <Typography><span style={{ color: " #032a4b" }}>Size</span> : {item?.size}</Typography>
                                    </div>
                                </div>
                            ))}
                            <div className='ordered-confirm-btn'>
                                <Button onClick={() => setCurrentStep(1)}>Confirm</Button>
                            </div>
                        </React.Fragment>
                    )}
                    {currentStep === 1 && (
                        <React.Fragment>
                            <Grid container spacing={3} rowSpacing={3} alignItems="stretch" >
                                {address.map((addr, index) => (
                                    <Grid size={{ sm: 12, xs: 12, md: 6, lg: 4 }} >
                                        <div className="address_info_box" key={index}>
                                            <div className="address_header">

                                                <div className="default-address">
                                                    <FormControlLabel
                                                        control={
                                                            <Radio
                                                                checked={selectedAddress?._id === addr._id}
                                                                onChange={() => setSelectedAddress(addr)}
                                                                sx={{
                                                                    color: '#E37B00',
                                                                    '&.Mui-checked': {
                                                                        color: '#E37B00',
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                    />
                                                    <Typography variant="h5">{addr?.name}</Typography>
                                                    {addr?.default === true ? <Button>Default</Button> : null}
                                                </div>

                                            </div>

                                            <div className="add-address">
                                                <List>
                                                    <Typography variant="h5">Address:</Typography>
                                                    <ListItem>
                                                        {addr?.line_1}, {addr?.line_2}, {addr?.landmark}, {addr?.city},{" "}
                                                        {addr?.state}, {addr?.pincode}.
                                                    </ListItem>
                                                    <Typography variant="h5">Mobile number:</Typography>
                                                    <ListItem>{addr?.mobile}</ListItem>
                                                </List>
                                            </div>

                                            <div className="catalogue-delivery-btn">
                                                {/* <Button
                                                    className="edit-btn"
                                                    onClick={() => { setOpenDialog(true) }}
                                                >
                                                    Add Address
                                                </Button> */}
                                                <Button
                                                    className="confirm-btn"
                                                    onClick={handleCreateorder}
                                                    disabled={selectedAddress?._id !== addr._id || loading}
                                                    style={{
                                                        backgroundColor: selectedAddress?._id === addr._id ? '#e37b00' : 'lightgray',
                                                        cursor: selectedAddress?._id === addr._id ? 'pointer' : 'not-allowed',
                                                    }}
                                                >
                                                    {selectedAddress?._id === addr._id ? (
                                                        loading ? (
                                                            <CircularProgress size={20} sx={{ color: "#fff" }} />
                                                        ) : (
                                                            "Confirm"
                                                        )
                                                    ) : (
                                                        "Confirm"
                                                    )}

                                                </Button>

                                            </div>

                                        </div>
                                    </Grid>
                                ))}
                            </Grid>
                            <div className="catalogue-delivery-btn">
                                <Button
                                    className="edit-btn"
                                    onClick={() => { setOpenDialog(true) }}
                                >
                                    Add Address
                                </Button>
                            </div>
                        </React.Fragment>
                    )}
                    {currentStep === 2 && (
                        <div className='cart-no-items'>
                            <img src={order_complete} alt='order_complete' />
                            <Typography>Order placed successfully!</Typography>
                        </div>
                    )}
                    <Admin_addAddress
                        openDialog={openDialog}
                        setOpenDialog={setOpenDialog}
                        FetchAddress={FetchAddress}
                    />
                </div>
            </React.Fragment >
        </React.Fragment >
    );
};

export default Ordereduser;
